import * as React from 'react';
import MailchimpSubscribe, { EmailFormFields, FormHooks } from "react-mailchimp-subscribe";
import { IMailchimpFormContainerProps } from './MailchimpFormContainer.types';

// pass the custom form component and post url as props, so that we can utilize this for more than one mailchimp embedded forms.
export const MailchimpFormContainer = (props:IMailchimpFormContainerProps) => {
    // const postUrl = `https://parts-unlimited.us8.list-manage.com/subscribe/post?u=e8b65eb0ab098463c06adcfdb&amp;id=fe4e489c07`;
    const postUrl = props.postUrl;
    const validateForm = (subscribe:any) => (formData: EmailFormFields) => subscribe(formData);
    // const renderSubscribe = ({ subscribe, status, message } : FormHooks<any>) => (
    //     <CustomForm
    //         status={status} 
    //         message={message}
    //         onValidated={validateForm(subscribe)}
    //     />
    // )
    const renderSubscribe = ({ subscribe, status, message } : FormHooks<any>) => (
        <props.customForm
            status={status} 
            message={message}
            onValidated={validateForm(subscribe)}
        />
    )

    return (
        <div className="mc__form-container">
            <MailchimpSubscribe
                url={postUrl}
                render={renderSubscribe}
            />
        </div>
    );
};